export const SAVINGS_STAMP_TEST_IDS = {
    SAVINGS_STAMP_CONTAINER: "SAVINGS_STAMP_CONTAINER",
    SAVINGS_STAMP_CONTENT: "SAVINGS_STAMP_CONTENT",
};
